module.exports = __webpack_public_path__ + "img/541344f.png";